var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "253", height: "170", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    React.createElement(
      "defs",
      null,
      React.createElement("rect", { id: "boosts-packages-spotlight-a", y: ".289", width: "253", height: "168", rx: "2" })
    ),
    React.createElement(
      "g",
      { transform: "translate(0 .711)", fill: "none", fillRule: "evenodd" },
      React.createElement(
        "mask",
        { id: "boosts-packages-spotlight-b", fill: "#fff" },
        React.createElement("use", { xlinkHref: "#boosts-packages-spotlight-a" })
      ),
      React.createElement(
        "g",
        { mask: "url(#boosts-packages-spotlight-b)" },
        React.createElement(
          "g",
          { transform: "translate(9)" },
          React.createElement("path", { fill: "#8C336E", opacity: ".601", d: "M74 0l129 126.624L91.407 141 .556 0z" }),
          React.createElement("path", { fill: "#8C336E", opacity: ".601", d: "M225 0L96 126.624 207.593 141 298.444 0z" }),
          React.createElement("ellipse", { fill: "#FF4DC4", cx: "150", cy: "135.5", rx: "60", ry: "19.5" })
        )
      )
    )
  );
});


// WEBPACK FOOTER //
// ./src/apps/boosts/components/svgs/spotlight.svg